import React, { useEffect, useRef, useState } from 'react'
import MicroComponents from './MicroComponents'
import { useDispatch, useSelector } from 'react-redux'
import { ElementWrapper } from './ElementWrapper'
import { containers } from '../constants'
import { getContainerField, onDrop } from '../helpers'
import { clearSelectedItems, setSelectedFormItemId, updatedSelectedeElements } from '../../../../../stateManager/store/formCreation_v2/actions'
import { getMargin, getPadding } from '../helpers/generateStyles'
import { setMultipleSelectionv2 } from '../../../../../stateManager/store/contextMenuv2/action'
import { ItemTypes } from '../types/ItemTypes'
import { useDrop } from 'react-dnd'
import { HandleContainersV3 } from '../helpers/HandleLayoutComponentsv3'

export function FormWizardSteps(props: any) {
  const { children } = props;
  const { id, fields, type, properties, isChildAsset, isAsset } = props?.element;
  const { isCheckedIn, deviceType } = props
  const wizardStyle = properties?.styles[deviceType]?.wizardStyle
  const { components, isCoreV3, selectedElementId } = useSelector((state: any) => state.formJson);
  const [currentWizardId, setCurrentWizardId] = useState<any>("")
  const [showStep, setShowStep] = useState(false);
  const wizardFields = components[currentWizardId]?.fields;
  const dispatch = useDispatch();
  const stepRefs: any = useRef([]);

  useEffect(() => {
    if (fields && fields.length && (currentWizardId === "" || !fields.includes(currentWizardId))) {
      setCurrentWizardId(fields[0])
    }
  }, [fields, currentWizardId])

  useEffect(() => {
    const handleScroll = () => {
      const stickyDiv = document.getElementById(`${type}-${id}`);
      const scrollableElement = document.querySelector("#mainCanvas");
      const formWizardMobileElement = document.querySelector('.formWizard-mobile-fixed-header');
      if (!stickyDiv) return;

      const childTop = formWizardMobileElement ? formWizardMobileElement.getBoundingClientRect().top : 0;
      const parentTop = scrollableElement ? scrollableElement.getBoundingClientRect().top: 0;
      // Calculate child position relative to the parent
      const childRelativeTop = childTop - parentTop;

      // Show the circle progress icon when the step is at the top
      if (Math.floor(childRelativeTop) <= 0) {
        setShowStep(true);
      } else {
        setShowStep(false);
      }
    };

    const scrollableElement = document.querySelector(`#${type}-${id}`);
    if (scrollableElement) {
      scrollableElement.addEventListener('scroll', handleScroll);

      // Clean up the event listener on component unmount
      return () => {
        scrollableElement.removeEventListener('scroll', handleScroll);
      };
    } else {
      console.error('Element with id "mainGrid" not found.');
    }
  }, []);

  const combinedClassName = properties?.config?.classNameTags?.join(" ") || [];
  const newStyles: { [key: string]: any } = {
    ...props?.element?.properties?.styles?.common,
    ...props?.element?.properties?.styles?.[deviceType],
  };
  const { height, heightMode, width, widthMode, fontFamily = 'Outfit', wizardWidth, wizardWidthMode } = newStyles;
  const getWidth = (): string => {
    if (widthMode === 'auto') {
      return "auto"
    } else if (widthMode === 'min-content') {
      return "min-content"
    } else if (widthMode === 'max-content') {
      return "max-content"
    } else if (width) {
      return `${width}${newStyles.widthMode}`;
    }
    return "100%"
  }
  const getHeight = (): string => {
    let returnVal = "";
    if (heightMode === 'auto') {
      returnVal = "auto"
    } else if (heightMode === 'min-content') {
      returnVal = "min-content"
    } else if (heightMode === 'max-content') {
      returnVal = "max-content"
    } else if (heightMode === '%' || heightMode === 'px') {
      returnVal = `${height}${heightMode}`
    } else if (!fields.length) {
      returnVal = "82px"
    } else {
      returnVal = "100%"
    }
    return returnVal
  }
  const elementStyle = properties?.styles || {};
  const marginStyle = getMargin(elementStyle[deviceType])
  const styles = props?.element?.properties?.styles?.[deviceType] || {};
  const paddingStyle = getPadding(styles);
  const wizardStyleV3: React.CSSProperties = {
    width: getWidth(),
    height: getHeight(),
    ...marginStyle,
    ...paddingStyle,
    fontFamily: fontFamily.name ? fontFamily.name !== 'Default' ? fontFamily.name : 'Outfit' : 'Outfit',
    marginTop: '0px',
    display: styles?.visible ? 'flex' : 'none',
    flexDirection: deviceType === 'Sm' ? 'column' : 'row',
    overflow: deviceType === 'Sm' ? 'auto' : 'hidden',
    flexShrink: 0
  }

  const color1 = wizardStyle && wizardStyle?.color1 ? wizardStyle?.color1 : '#1B1B1A';
  const color2 = wizardStyle && wizardStyle?.color2 ? wizardStyle?.color2 : '#EDC951';
  const color3 = wizardStyle && wizardStyle?.color3 ? wizardStyle?.color3 : '#FFFFFF';
  const color4 = wizardStyle && wizardStyle?.color4 ? wizardStyle?.color4 : '#F2F2F2';
  const color5 = wizardStyle && wizardStyle?.color5 ? wizardStyle?.color5 : '#494948';

  const getWizardcontentStyles = (): React.CSSProperties => {
    return {
      overflowX: "hidden",
      height: deviceType === 'Sm' ? "auto" : "100%",
      display: "flex",
      flexDirection: "column",
      width: `${deviceType === 'Sm' ? `${wizardWidth}${wizardWidthMode}` : (wizardWidth ? `calc(100% - ${wizardWidth}${wizardWidthMode} - ${selectedElementId === currentWizardId ? '1.65px' : '0px'})` : '100%')}`,
      zIndex: 0,
      position: 'relative',
      flexGrow: deviceType === 'Sm' ? 1 : 0,
    }
  }

  const handleSelect = (e: React.MouseEvent<HTMLDivElement>, id: any,) => {
    e.stopPropagation();
    if (e.shiftKey && !isChildAsset) {
      dispatch(setMultipleSelectionv2(true));
      dispatch(updatedSelectedeElements(id));
    } else {
      dispatch(setMultipleSelectionv2(false));
      dispatch(
        setSelectedFormItemId({
          id,
          isAssetInstanceSelected: isAsset || isChildAsset,
        })
      );
      dispatch(clearSelectedItems())
    }
  };

  const selectWizardStep = (stepId: any) => {
    setCurrentWizardId(stepId)
  }

  const [{ isOverCurrent, canDrop }, drop] = useDrop({
    accept: [ItemTypes.ELEMENT, ItemTypes.COMPONENT, ItemTypes.TEMPLATE],
    canDrop: (item: any) => {
      // 1. the source grid itself gets dropped
      if (id === item.json.id) {
        return false;
      }

      if (item.json.type === "Spacer") {
        return false;
      }

      // 2. the dragged item is already present in the grid
      if (item.type === ItemTypes.ELEMENT && item.json.parentId === id) {
        return false;
      }

      return true;
    },
    collect: (monitor) => {
      return {
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
      };
    },
    drop: async(item: any) => {
      if (isOverCurrent) {
        let id: any;
        if (item?.json?.type !== 'FormWizard') {
          id = onDrop({ id: currentWizardId }, item, deviceType, isCoreV3);
        }
        if (item?.json?.type === "TabBar") {
          let data: any = {
            type: "Component",
            json: {
              type: 'Tab',
              label: 'Tab 1',
              value: "tab 1"
            }
          }
          onDrop({ id }, data, deviceType, isCoreV3)
        } else if (item?.json?.type === "FormWizard") {
          onDrop({ id: currentWizardId }, {type: ItemTypes.FORMWIZARD, json: {}}, deviceType, isCoreV3);
        }
      }
    },
  });

  const isActive = isOverCurrent && canDrop;
  const animationClass = isActive ? "drop-active" : canDrop ? "drop-passive" : "";

  const headerStyle = properties?.config?.showWizardHeader ? '-webkit-box' : 'none'

  const findTheCurrentWizard = (index: number): React.CSSProperties => {
    const currentWizardStepIndex = fields.indexOf(currentWizardId);
    let backgroundColor = color2;
    let color = color1;
    let border = `2px solid ${color1}`;
    let width = '36px';
    let height = '36px';
    let outline = '';
    if (currentWizardStepIndex > index) {
      backgroundColor = color1;
      color = color3;
      border = `2px solid ${color1}`
    } else if (currentWizardStepIndex === index) {
      backgroundColor = color1;
      let updatedColor = color1.length > 7 ? color1.slice(0, -2) : color1
      outline = `4px solid ${updatedColor}80`;
      color = color3;
    }
    return {
      backgroundColor: backgroundColor,
      color: color,
      borderRadius: '100%',
      width: width,
      height: height,
      border: border,
      fontWeight: 500,
      textAlign: 'center',
      verticalAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      outline: outline,
      fontSize: '16px',
      flexShrink: 0,
      flexGrow: 0,
      boxSizing: 'border-box'
    }
  }

  const ellipsisStyle: any = {
    "-webkit-box-orient": "vertical",
    display: "-webkit-box",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
  };

  const stepHeaderStyle: any = {
    WebkitLineClamp: `${deviceType === 'Sm' ? '1' : '2'}`,
  }

  const stepHeaderStyleForMobile: any = {
    WebkitLineClamp: '2',
  }

  const descriptionStyle: any = {
    "-webkit-box-orient": "vertical",
    display: "-webkit-box",
    overflow: 'hidden',
    wordBreak: 'break-word'
  }

  const stepTitleStyle = (desc: string, title: string): React.CSSProperties => {
    let design: any;
   if(!properties?.config?.showStepsDescription || (desc === '' || desc === null || desc === undefined) || (title === '' || title === null || title === undefined)) {
    design = {
      display: 'flex',
      alignItems: 'center'
    }
   }
   return design
  }

  const findCurrentStep = () => {
    const currentWizardStepIndex = fields.indexOf(currentWizardId);
    return ( currentWizardStepIndex + 1 )
  }

  const CircularProgressBar = ({ size = 35, progress = 0, strokeWidth = 4 }: any) => {
    const center = size / 2;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (progress/100) * circumference;
  
    return (
      <svg width={size} height={size}>
        <circle
          stroke={color4}
          fill="transparent"
          strokeWidth={strokeWidth}
          r={radius}
          cx={center}
          cy={center}
        />
        <circle
          stroke={color5}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          r={radius}
          cx={center}
          cy={center}
          style={{ transition: 'stroke-dashoffset 0.35s', transform: `rotate(-90deg)`,
            transformOrigin: '50% 50%', }}
          strokeLinecap="round"
        />
        <text
          x={center}
          y={center}
          textAnchor="middle"
          dy="4.5px"
          fontSize="12px"
          fill={color1}
          fontWeight={500}
        >
          {`${findCurrentStep()}`}
        </text>
      </svg>
    );
  };

  const handleSelectwizardStep = (stepId: string, index: number) => {
    const container = document.querySelector('.formwizard-steps');
    if (container && stepRefs.current[index]) {
      const stepElement = stepRefs.current[index];
      const containerRect = container.getBoundingClientRect();
      const stepRect = stepElement.getBoundingClientRect();
      
      // Calculate the required scrollLeft to center the step
      const scrollLeft =
        container.scrollLeft + stepRect.left - containerRect.left - (containerRect.width / 2) + (stepRect.width / 2);

      // Scroll the parent container
      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
    selectWizardStep(stepId);
  }


  return (
    <div className={`relative ${combinedClassName} full-height align-items-start formWizard-section`} style={wizardStyleV3} id={`${type}-${id}`}
      onClick={(e) => handleSelect(e, id)}
    >
      {deviceType === 'Sm' ? (<>
        <div style={{ backgroundColor: color2, height: 'auto', display: "block", width: `${wizardWidth ? wizardWidth : '0'}${wizardWidthMode}`, paddingTop: '1px', paddingBottom: '4px' }} className='formWizard-mobile'>
          <div className="text-center grid grid-cols-5 gap-5" style={{ marginTop: '23px', padding: '0px 24px', height: '35px', display: (!properties?.config?.showWizardStepsStatus &&  !properties?.config?.showWizardHeader) ? 'none': ''}}>
            <div className='col-span-4 p-0 flex items-center formwizard-title'>
              <h4 style={{...ellipsisStyle, ...stepHeaderStyle, textAlign: 'left', fontSize: '20px', fontWeight: 500, display: `${headerStyle}`, color:  color1 }}>{properties?.config?.title ? properties?.config?.title : ''}</h4>
            </div>
            <div className='col-span-1 pr-0 formwizard-step-count' style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
              <div style={{ display: properties?.config?.showWizardStepsStatus ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <CircularProgressBar size={35} progress={(findCurrentStep()/fields.length)*100} strokeWidth={4} />
              </div>
            </div>
          </div>
          <div style={{ padding: '0px 24px', width: '100%', display: 'flex', overflowX: 'auto', scrollbarColor: `${color2} ${color2}`, scrollSnapType: 'x mandatory', paddingTop: `${!properties?.config?.showWizardStepsStatus &&  !properties?.config?.showWizardHeader ? '24px' : '10px'}` }} className='formwizard-steps'>
            {fields && fields.map((stepId: any, i: number) => {
              const currentWizardStepIndex = fields.indexOf(currentWizardId);
              let prevIndex;
              let sameIndex;
              prevIndex = (i === (currentWizardStepIndex - 1))
              sameIndex = (i === currentWizardStepIndex)
              return <div style={{ margin: '5px 36px 3px 0px', display: 'flex', position: 'relative', cursor: 'pointer', height: '50px', scrollSnapAlign: 'center' }} id={`formwizard-step-${stepId}`} 
                onClick={(e) => {
                  handleSelectwizardStep(stepId, i);
                  handleSelect(e, stepId);
                }
                } key={i} ref={(el) => {stepRefs.current[i] = el}}>
                  <div style={findTheCurrentWizard(i)} className='formwizard-step'>{i + 1}</div>
                  {fields.length !== (i + 1) &&
                    <div style={{ width: '100%', position: 'absolute', left: `${prevIndex ? '32px' : sameIndex ? '40px' : '36px'}`, top: '18px', borderTop: `2px solid ${color1}` }}></div>
                  }
                </div>
            })}
          </div>
        </div>
          <div style={{  backgroundColor: color2, height: 'auto', width: `${wizardWidth ? wizardWidth : '0'}${wizardWidthMode}`, padding: '10px 24px 15px 24px', position: 'sticky', top: 0, zIndex: 999, marginTop: '-11px' }} className="step-title formWizard-mobile-fixed-header">
            <div className={showStep ? 'grid grid-cols-5' : ''} style={{ height: 'max-content', paddingTop: `${showStep ? '10px' : '0px'}` }}>
              <div className='flex items-center col-span-4 formwizard-step-title'>
                <h5 style={{ ...ellipsisStyle, ...stepHeaderStyleForMobile, margin: '0px',fontSize: '15px',fontWeight: 600, color: color1, alignItems: 'center' }}>{components[currentWizardId]?.title}</h5>
              </div>
              {showStep &&
                <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'baseline' }} className='col-span-1 formwizard-step-count'>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <CircularProgressBar size={35} progress={(findCurrentStep()/fields.length)*100} strokeWidth={4} />
                  </div>
                </div>
              }
            </div>
            {properties?.config?.showStepsDescription && <p style={{ ...descriptionStyle, margin: '0px', fontSize: '13px', color: color5 }} className='formwizard-step-description'>{components[currentWizardId]?.description}</p>}
          </div>
      </>
      ) : (
        <div style={{ backgroundColor: color2, height: '100%', display: "flex", flexDirection: 'column', width: `${wizardWidth ? wizardWidth : '0'}${wizardWidthMode}`, overflowY: 'hidden'}} className='formwizard-desktop'>
          <div className="text-center flex grid grid-cols-5 gap-2" style={{ marginTop: '25px', padding: '0px 24px', marginBottom: '25px', alignItems: 'center' }}>
            <div className={`formwizard-desktop-title p-0 d-flex justify-content-start align-items-center ${wizardWidth < 20 ? 'col-span-3' : 'col-span-4'} mr-4`}>
              <h4 style={{ ...ellipsisStyle, ...stepHeaderStyle, textAlign: 'left', fontSize: '20px', fontWeight: 500, display: `${headerStyle}`, color:  color1 }}>{properties?.config?.title ? properties?.config?.title : ''}</h4>
            </div>
            <div className={`pr-0 pl-0 formwizard-desktop-step-count ${wizardWidth < 20 ? 'col-span-2' : 'col-span-1'}`} style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>
                <div style={{ justifyContent: 'center', alignItems: 'center', height: '100%', display: properties?.config?.showWizardStepsStatus ? 'flex' : 'none' }}>
                  <CircularProgressBar size={35} progress={(findCurrentStep()/fields.length)*100} strokeWidth={4} />
                </div>
            </div>
          </div>
          <div style={{ padding: '6px 24px 0px 24px', overflowY: 'auto', scrollbarColor: `${color2} ${color2}` }} className='formwizard-desktop-steps'>
            {fields && fields.map((stepId: any, i: number) => {
              const stepDetails = components[stepId];
              const currentWizardStepIndex = fields.indexOf(currentWizardId);
              let prevIndex;
              let sameIndex;
              prevIndex = (i === (currentWizardStepIndex - 1))
              sameIndex = (i === currentWizardStepIndex)
              return (<>
                <div style={{ marginBottom: '30px', width: '100%', position: 'relative' }} 
                  onClick={(e: any) => {
                      selectWizardStep(stepId);
                      handleSelect(e, stepId);
                    }} className='flex'>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={findTheCurrentWizard(i)} className='formwizard-desktop-step'>{i + 1}</div>
                    {fields.length !== (i + 1) &&
                      <div style={{ height: '100%', position: 'absolute', top: `${prevIndex ? '26px' : sameIndex ? '40px' : '36px'}`, borderLeft: `2px solid ${color1}` }}></div>
                    }
                  </div>
                  {((properties?.config?.showStepsDescription && stepDetails?.description !== '') || stepDetails?.title !== '') &&
                    <div style={{ ...stepTitleStyle(stepDetails?.description, stepDetails?.title), paddingLeft: '15px', width: '80%' }}>
                      <h5 style={{ ...ellipsisStyle, ...stepHeaderStyle, margin: '0px',fontSize: '15px',fontWeight: 600, color: color1 }} className='formwizard-desktop-step-title'>{stepDetails?.title}</h5>
                      {properties?.config?.showStepsDescription && <p style={{ ...descriptionStyle, margin: '0px', fontSize: '13px', color: color5 }} className='formwizard-desktop-step-description'>{stepDetails?.description}</p>}
                    </div>
                  }
                </div>
              </>)
            })}
          </div>
        </div>
      )
      }
      <div id={`FormWizardStep-${currentWizardId}`} style={getWizardcontentStyles()} className={animationClass} ref={(ref: any) => drop(ref)} onClick={(e) => handleSelect(e, currentWizardId)}>
          {
            wizardFields && wizardFields.map((fieldId: string, index: any) => {
              const element = components[fieldId];
              const parentElement: any =
                element.parentId && components[element.parentId];
                  return (
                    <>
                    {containers.includes(element.type) ? (
                        <HandleContainersV3 key={fieldId} isCheckedIn={isCheckedIn} element={element} deviceType={deviceType} index={index} />
                      ) : (
                        <MicroComponents element={element} deviceType={deviceType} />
                      )}
                    </>
                  )
            })
          }
        </div>
    </div>
  )
}

